import { render } from "./EditAssignment.vue?vue&type=template&id=295968e8&scoped=true&ts=true"
import script from "./EditAssignment.vue?vue&type=script&lang=ts"
export * from "./EditAssignment.vue?vue&type=script&lang=ts"

import "./EditAssignment.vue?vue&type=style&index=0&id=295968e8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-295968e8"]])

export default __exports__